import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

  /**
   * Map of custom validator functions
   */
  public validatorFunctions: { [key: string]: ValidatorFn } = {
    'signedDateAfterReceivedDate': (control: AbstractControl): ValidationErrors | null => {
      const formGroup = control.parent;
      if (!formGroup) return null;
      
      const signedDate = formGroup.get('signedDate')?.value;
      const receivedDate = formGroup.get('receivedDate')?.value;
      
      if (!signedDate || !receivedDate) return null;
      
      const signedDateObj = new Date(signedDate);
      const receivedDateObj = new Date(receivedDate);

      if (signedDateObj < receivedDateObj) {
        return { 'signedDateAfterReceivedDate': true };
      }
      return null;
    },
    'disableFutureDates': (control: AbstractControl): ValidationErrors | null => {
      let value = control.value;
      if (value && new Date(value) > new Date()) {
        return { futureDateNotAllowed: true };
      }
      return null;
    },
    'arrayLength': (control: AbstractControl): ValidationErrors | null => {
      const length = 1; // Default length, should be overridden when getting validator
      if (control.value === null || control.value === undefined) {
        return null;
      }
      if (!Array.isArray(control.value)) {
        return { 'arrayLength': { required: length, actual: 'Not an array' } };
      }
      return control.value.length === length ? null : { 'arrayLength': { required: length, actual: control.value.length } };
    },
    'range': (control: AbstractControl): ValidationErrors | null => {
      const range: [number, number] = [0, 100]; // Default range, should be overridden when getting validator
      if (control.value === null || control.value === undefined || control.value === '') {
        return null;
      }
      const numValue = parseFloat(control.value);
      return !isNaN(numValue) && numValue >= range[0] && numValue <= range[1] ? 
        null : { 'range': { required: range, actual: control.value } };
    },
    'uuid': (control: AbstractControl): ValidationErrors | null => {
      if (control.value === null || control.value === undefined || control.value === '') {
        return null;
      }
      
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return uuidRegex.test(control.value) ? null : { 'uuid': { actual: control.value } };
    },
    'minDate': (control: AbstractControl): ValidationErrors | null => {
      // This is a placeholder. The actual implementation requires a reference to minDateField
      // and will be handled by the getValidator method
      return null;
    }
  };

  constructor() { }

  /**
   * Get a validator function by key
   * @param key The key of the validator function
   * @param params Optional parameters for the validator
   * @returns The validator function
   */
  getValidator(key: string): ValidatorFn {
    if (!this.validatorFunctions[key]) {
      console.error(`Validator with key '${key}' not found`);
      return () => null;
    }
    return this.validatorFunctions[key];
  }

}
